<ng-container *ngIf="featureData != undefined && (featureData | json) != '{}'">
    <div class="whitebg">
        <div class="container">
            <div class="occupation-section">
                <div class="occupation-left">
                    <div class="container mt-4">
                        <h2>Why Choose ExpediUSA?</h2>
                        <div class="row">
                            <div class="col-md-12 mt-2">
                                <h3>For Job Seekers:</h3>
                                <ul>
                                    <li>Find relevant government contractor jobs without digging through unrelated postings.</li>
                                    <li>Connect directly with companies hiring for U.S. government missions.</li>
                                    <li>Military veterans are encouraged to apply for impactful roles.</li>
                                </ul>
                            </div>
                            <div class="col-md-12">
                                <h3>For Employers:</h3>
                                <ul>
                                    <li>Access qualified, mission-driven candidates with relevant experience.</li>
                                    <li>Source talent with security clearances or clearable backgrounds.</li>
                                    <li>Hire professionals ready to contribute from day one.</li>
                                </ul>
                            </div>
                        </div>
                        <p class="mt-4">Join ExpediUSA today and take the next step toward meaningful work that supports the nation's most critical missions.</p>
                    </div>

                    <!-- <div [innerHtml]="featureData.description"></div> -->
                    <a routerLink="/about-us" class="btn btn-primary">{{'SHARED.ELEMENT.FEATURE.LEARN_MORE' | translate}}</a>
                </div>
                <div class="">
                    <div class="occupation-img">
                        <div class="img1">
                            <figure><img src="{{env.SITE_IMAGE_URL}}featimg.jpg" alt="img" width="457px" height="408px"></figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>